import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { ReactComponent as TrashCanIcon } from "../../../../images/trash-can.svg";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { removeUserFromCompany } from "services";
import { CustomButton } from "ui";

export const RemoveUserFromCompanyButton = observer(({ userId }: { userId: string }) => {
  const { actionModals, companyCard, companyUsers } = useStores();

  const removeUserFromCompanyHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    actionModals.open(
      () => (
        <ConfirmationModal
          text="Вы уверены, что хотите отключить пользователя от компании?"
          successText="Пользователь отключен от компании"
          buttonText="Отключить"
          calledQuery={() => removeUserFromCompany({ id: companyCard.card.id, userId: userId })}
          onSuccess={() => {
            setTimeout(() => {
              companyUsers.fetch();
            }, 1000);
          }}
        />
      ),
      {
        ...confirmationModalConfigs,
        onClose: () => actionModals.closeAll(),
      }
    );
  };
  return (
    <CustomButton
      type="link"
      size="small"
      icon={<TrashCanIcon />}
      onClick={removeUserFromCompanyHandler}
      tooltip="Отключить пользователя от компании"
    />
  );
});
